import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";

export default class FlagFirstDown extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            ruleContext.awardFirstDown &&
            gameContext.gameConfig.general.firstDownFlagStyle > 0 &&
            [
                FootballState.EndOfPlay,
                FootballState.NoPenaltyEndOfPlay,
                FootballState.GameStart,
                FootballState.CoinToss,
                FootballState.StartPeriod
            ].some((state) => state === fragment.associatedState)
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { gameConfig } = gameContext;

        gameContext.down = 1;
        ruleContext.setAwardFirstDown(false);

        if (gameContext.isVisitorPossession()) {
            const yardLines = gameConfig.general.firstDownYardSet.filter(
                (f) => {
                    return f < gameContext.fieldPosition;
                }
            );
            gameContext.firstDownAt =
                yardLines.length > 0 ? Math.max(...yardLines) : 0;
        }
        if (gameContext.isHomePossession()) {
            const yardLines = gameConfig.general.firstDownYardSet.filter(
                (f) => {
                    return f > gameContext.fieldPosition;
                }
            );
            gameContext.firstDownAt =
                yardLines.length > 0
                    ? Math.min(...yardLines)
                    : gameContext.getFieldLength();
        }
    }
}
